import type { DeviceResponseV5 } from '@emma/api_client/types';
import { Flex } from '@lego/klik-ui';
import { DeviceDeployment } from '@/components/device/DeviceDeployment';

type Props = {
  device: DeviceResponseV5;
};

export const DeviceDeployments = ({ device }: Props) => {
  return (
    <Flex direction="column" gap={8}>
      <DeviceDeployment device={device} />
    </Flex>
  );
};
